import { render } from 'react-dom';
import React from 'react';
import { Provider } from 'react-redux';
import reducers from './app/reducers';
import App from './app/App';
import configureStore from '../store/configureStore';

export default function boostrapReact() {
  const store = configureStore(reducers);

  render(
    <Provider store={store}>
      <App />
    </Provider>,
    document.getElementById('root'),
  );
}
